import { render } from "./ProductCategoriesTreeItem.vue?vue&type=template&id=01f1b650&scoped=true&ts=true"
import script from "./ProductCategoriesTreeItem.vue?vue&type=script&lang=ts"
export * from "./ProductCategoriesTreeItem.vue?vue&type=script&lang=ts"

import "./ProductCategoriesTreeItem.vue?vue&type=style&index=0&id=01f1b650&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/bouwstenen/Bouwsteen_BuildAndDeploy_Vue_Frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01f1b650"]])

export default __exports__